import { render, staticRenderFns } from "./VaultRewards.vue?vue&type=template&id=3f3bd75c&scoped=true&"
import script from "./VaultRewards.vue?vue&type=script&lang=js&"
export * from "./VaultRewards.vue?vue&type=script&lang=js&"
import style0 from "./VaultRewards.vue?vue&type=style&index=0&id=3f3bd75c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3bd75c",
  null
  
)

export default component.exports